import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/_app/privacy")({
  head: () =>
    buildHead({
      title: "Privacy Policy | LohaLink",
      description:
        "How LohaLink collects, uses, and protects business data for secure B2B scrap metal trading in India.",
      canonical: "/privacy",
      ogType: "article",
    }),
  component: lazyRouteComponent(() => import("@/pages/Privacy")),
});
